import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import { api } from '../utils/api'
import ThemeToggle from '../components/ThemeToggle'
import { sanitizeHTML } from '../utils/sanitize'

const VerifyEmail = () => {
  const { token } = useParams()
  const [loading, setLoading] = useState(true)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)
  const hasVerified = useRef(false)

  useEffect(() => {
    // Prevent double API calls in React Strict Mode
    if (hasVerified.current) return
    hasVerified.current = true

    const handleVerification = async () => {
      try {
        const response = await api.get(`/auth/verify/${token}`)
        setResult(response.data)
      } catch (error) {
        setError(error.response?.data?.error || 'Er is een fout opgetreden')
      } finally {
        setLoading(false)
      }
    }

    handleVerification()
  }, [token])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="absolute top-4 right-4">
          <ThemeToggle />
        </div>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Je e-mailadres wordt geverifieerd...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="absolute top-4 right-4">
          <ThemeToggle />
        </div>
        <div className="max-w-md w-full text-center">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <div className="text-6xl mb-4">❌</div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Verificatie mislukt
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              {error}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="max-w-2xl w-full">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
          {/* Header */}
          <div className="px-6 py-8 text-center bg-green-50 dark:bg-green-900/30">
            <div className="text-6xl mb-4">✅</div>
            <h1 className="text-2xl font-bold mb-2 text-green-900 dark:text-green-100">
              E-mailadres bevestigd!
            </h1>
            <p // nosemgrep: eslint.react-dangerouslysetinnerhtml -- sanitized by DOMPurify
              className="text-lg text-green-700 dark:text-green-300"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(result?.message) }}
            />
          </div>

          {/* Actions */}
          <div className="px-6 py-6 bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600">
            <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
              <button
                onClick={() => window.close()}
                className="hover:text-gray-700 dark:hover:text-gray-200 hover:underline cursor-pointer transition-colors"
              >
                Je kunt dit venster sluiten.
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmail
